import styled from 'styled-components'

export const Overalay = styled.div`
  position: fixed;
  z-index: 1000;
  top: 0%;
  left: 0%;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`

export const Modal = styled.div`
  width: 520px;
  font-family: Roboto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  padding: 24px;
  background-color: ${({ theme }) => theme.cor68}!important;
`

export const TituloWrapper = styled.div`
  display: grid;
  grid-template-columns: 14px 1fr auto;
  align-items: center;
  gap: 16px;
`

export const BannerWrapper = styled.div`
  padding-top: 16px;
`

export const TituloModal = styled.h1`
  margin: 0;
  font-weight: 400;
  font-size: 24px;
  color: ${({ theme }) => theme.cor9};
`

export const BotaoFechar = styled.button`
  height: 2.1875em;
  width: 2.1875em;
  background-color: transparent;
  border: none;
  padding: 0;
  outline: none !important;
`

export const Elipse = styled.img`
  height: 14px;
  width: 14px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.cor11};
  margin-top: 2px;
`

export const GrupoInput = styled.div`
  display: grid;
  gap: 10px;
`

export const TituloStatus = styled.h1`
  color: ${({ theme }) => theme.cor9};
  font-size: 18px;
  font-weight: bold;
  margin: 0;
`

export const InputLabel = styled.label`
  color: ${({ theme }) => theme.cor9};
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`

export const LabelDefault = styled.span`
  color: ${({ theme }) => theme.cor9};
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`

export const Form = styled.form`
  margin-top: 24px;
  display: grid;
  gap: 16px;
  grid-auto-columns: 100%;
`

export const ClienteSelecionado = styled.span`
  height: 38px;
  width: 100%;
  font-family: RobotoRegular;
  border: 0em;
  padding: 8px 12px;
  box-shadow: none;
  border-radius: 5em;
  color: ${({ theme }) => theme.cor9};
  background-color: ${({ theme }) => theme.cor27};
  align-items: center;
  font-family: RobotoRegular;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
`

export const MotivoBloqueio = styled.span`
  min-height: 38px;
  width: 100%;
  font-family: RobotoRegular;
  line-height: 24px;
  border: 0em;
  padding: 8px 12px;
  box-shadow: none;
  border-radius: ${({ usuarioBloqueio }) =>
    usuarioBloqueio ? '16px' : '24px'};
  color: ${({ theme }) => theme.cor9};
  background-color: ${({ theme }) => theme.cor27};
  align-items: center;
  font-family: RobotoRegular;
  font-size: 16px;
`

export const SetaDropdown = styled.img`
  transform: rotate(360deg);
`

export const Linha = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
`

export const LinhaSwitch = styled.div`
  display: grid;
  grid-template-columns: 55px 1fr;
  gap: 16px;
  align-items: end;
`

export const Input = styled.input`
  background-color: transparent;
  border: none;
  line-height: 1.0625em;
  outline: none;
  color: ${({ theme }) => theme.cor9};
  height: 38px;
  font-size: 16px;
  width: 100%;
  font-family: RobotoRegular;
  box-shadow: none;
  border-radius: 5em;
  background-color: ${({ theme }) => theme.cor27};
  padding: 8px 12px;

  ::placeholder {
    color: ${({ theme }) => theme.cor70}!important;
  }
`

export const InputWrapper = styled.div`
  width: 100%;
  height: 38px;
  position: relative;
  border-radius: 24px;
  padding: 8px 12px;
  color: ${({ theme }) => theme.cor9};
  background-color: ${({ theme }) => theme.cor27};
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const BotaoVerSenha = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
  outline: none !important;
`

export const BotaoGerarSenha = styled.button`
  gap: 8px;
  display: flex;
  align-items: center;
  font-weight: 700;
  justify-content: center;
  align-self: end;
  border: none;
  border-radius: 24px;
  height: 38px;
  color: ${({ theme }) => theme.cor38};
  background-color: ${({ theme }) => theme.cor64};
  box-shadow: 0px 3px 1px -2px #00000033;
  outline: none !important;
  text-transform: uppercase;
`

export const Aviso = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.cor9};
  font-weight: 600;
`

export const Divisor = styled.div`
  background-color: ${({ theme }) => theme.cor61};
  height: 1px;
`

export const BotoesWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  gap: 24px;
  justify-content: end;
`

export const BotaoConfirmar = styled.button`
  background-color: ${({ theme }) => theme.cor11};
  border: none;
  font-family: RobotoBold;
  font-size: 1em;
  font-weight: 700;
  height: 2.625em;
  min-width: 8.75em;
  padding: 0 1.875em;
  box-shadow: none;
  border-radius: 3.125em;
  outline: none;
  color: ${({ theme }) => theme.cor1};

  :disabled {
    background-color: ${({ theme }) => theme.cor61};
    color: ${({ theme }) => theme.cor62};
  }
`

export const BotaoCancelar = styled.button`
  font-family: RobotoBold;
  font-size: 1em;
  font-weight: 700;
  height: 2.625em;
  min-width: 8em;
  padding: 0 1.875em;
  border: 0.09375em solid ${({ theme }) => theme.cor11};
  color: ${({ theme }) => theme.cor11};
  background-color: transparent;
  box-shadow: none;
  border-radius: 3.125em;
  outline: none !important;
`

export const MensagemWrapper = styled.div`
  display: flex;
  gap: 12px;
`

export const Required = styled.span`
  color: ${({ theme }) => theme.cor12};
  font-weight: 600;
`

export const Span = styled.span`
  color: ${({ theme, isVendedor }) => (isVendedor ? theme.cor11 : theme.cor66)};
  font-weight: 600;
`
export const Permissoes = styled.div`
  display: grid;
  gap: 10px;
`

export const CheckboxEnviarSmsForaParqueWrapper = styled.div`
  label {
    margin: 0;
  }
`
